export enum TransactionType {
  CRYPTO = 'CRYPTO',
  BANK = 'BANK',
  EXCHANGE = 'EXCHANGE',
  CLEARJUNCTION = 'CLEARJUNCTION',
  PACKAGE = 'PACKAGE',
  SERVICE = 'SERVICE',
  PPG = 'PPG',
  CUSTODY = 'CUSTODY',
  INTERCASH = 'INTERCASH',
  RAILSBANK = 'RAILSBANK',
  DECTA = 'DECTA',
  MAINTAINING = 'MAINTAINING',
  CAMBRIDGE = 'CAMBRIDGE'
}

export function isTransactionType($: any): $ is TransactionType {
  return (Object.values(TransactionType) as Array<string>).indexOf($) > -1;
}

export enum TransactionSubType {
  DEPOSIT = 'DEPOSIT',
  WITHDRAW = 'WITHDRAW',
  EXCHANGE = 'EXCHANGE',
  TRANSFER = 'TRANSFER',
  PURCHASE = 'PURCHASE',
  CURRENCY_FEE = 'CURRENCY_FEE',
  COMMISSION = 'COMMISSION',
  PAYMENT = 'PAYMENT',
  CHARGEBACK = 'CHARGEBACK',
  CARD_TOP_UP = 'CARD_TOP_UP',
  BALANCE = 'BALANCE',
  ACCOUNT = 'ACCOUNT',
  CARD_CACHE_OUT = 'CARD_CACHE_OUT'
}

export enum TransactionStatus {
  NEW = 'NEW',
  APPROVAL = 'APPROVAL',
  APPROVED_BY_RISK_MANAGER = 'APPROVED_BY_RISK_MANAGER',
  APPROVED_BY_COMPLIANCE_MANAGER = 'APPROVED_BY_COMPLIANCE_MANAGER',
  EMAIL_APPROVAL = 'EMAIL_APPROVAL',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  ERROR = 'ERROR',
  FAILED = 'FAILED'
}

export enum TransactionRiskScore {
  UNKNOWN = 'UNKNOWN',
  PENDING = 'PENDING',
  GREEN = 'GREEN',
  YELLOW = 'YELLOW',
  RED = 'RED',
}

export interface Transaction {
    id?: number;
    accountToId?: number;
    accountFromId?: number;
    userId?: number;
    number?: string;
    type?: TransactionType;
    subType: TransactionSubType;
    transactionId?: string;
    addressFrom?: string;
    addressTo?: string;
    amountTo?: number;
    amountFrom?: number;
    rate?: number;
    rateUsd?: number;
    rateEur?: number;
    currencyCodeFrom?: string;
    currencyCodeTo?: string;
    amountToEur?: number;
    amountToUsd?: number;
    amountFromEur?: number;
    amountFromUsd?: number;
    total?: number;
    totalUsd?: number;
    totalEur?: number;
    currencyFeeCode?: string;
    currencyFeeAccountId?: number;
    currencyFeeAmount?: number;
    currencySystemFee?: number;
    currencyFeePercetage?: number;
    systemFeePercent?: number;
    systemFee?: number;
    txFee?: number;
    actualTxFee?: number;
    status?: TransactionStatus;
    riskScore?: TransactionRiskScore;
    note?: string;
    statusText?: string;
    confirmed: boolean;
    exchangePairId?: number;
    userBankAccountId?: number;
    productId?: number;
    createdDate?: Date;
    updatedDate?: Date;
    user?: any;
    history?: any;
    internalAddress?: boolean;
    detail?: any;
    accountFrom?: any;
    accountTo?: any;
    detailType?: string;
}
